<template>
  <v-app id="inspire">
    <div class="sales-tax-reports-wrap">
      <v-layout class="inv-top-header mb-4">
        <v-flex>
          <p class="text-uppercase caption mb-0">Billing</p>
          <h2 class="headline">Sales Tax Report</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 mb-0 mt-2"
          text
          small
          :disabled="loading || items.length === 0"
          @click="exportCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
        >
      </v-layout>

      <v-flex class="header-search-single">
        <v-container class="grid-list-md pa-0 mb-4 container--fluid">
          <v-layout class="wrap xs12">  
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu1"
                :label="`From Date`"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="fromDate"
                    :label="`From Date`"
                    persistent-hint
                    prepend-icon="event"
                    placeholder="Please Select"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  no-title
                  @input="menu1 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu2"
                :label="`To Date`"
                v-model="menu2"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="toDate"
                    :label="`To Date`"
                    persistent-hint
                    prepend-icon="event"
                    placeholder="Please Select"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  no-title
                  @input="menu2 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-btn
                large
                color="primary"
                dark
                class="mx-0 mt-1 mb-2"
                style="min-width: 50px; padding: 0 10px;"
                @click="initialize"
              >
                Apply
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loader-height="2"
          hide-default-footer
          disable-pagination
          class="elevation-1 table-org"
          :class="{'table-completed': !(loading)}"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item, index}">
            <tr class="items-body-row">
              <td>
                <span v-if="!no_data.includes(item.name)">{{ item.name }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.tax_rate)">{{ `${item.tax_rate}%` }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.product_tax_rate)">{{ `${item.product_tax_rate}%` }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.gross_sales)">${{ item.gross_sales }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.non_taxable_sales)">${{ item.non_taxable_sales }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.taxable_sales)">${{ item.taxable_sales }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.collected_tax)">${{ item.collected_tax }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr
              v-if="
                index === items.length - 1 &&
                items.length !== 0 &&
                !no_data.includes(taxReportSums) &&
                !no_data.includes(taxReportSums.taxable_sales) &&
                !no_data.includes(taxReportSums.non_taxable_sales) &&
                !no_data.includes(taxReportSums.collected_tax)
              "
              class="totals-row"
              style="border-bottom: 1px solid #ccc; background-color: #eaeaea; border-color: #eaeaea;"
            >
              <td style="font-size: 14px!important;">
                <strong>Totals:</strong>
              </td>
              <td style="font-size: 14px!important;">
              </td>
              <td style="font-size: 14px!important;">
              </td>
              <td style="font-size: 14px!important;">
                <strong>{{
                  `$${
                    parseFloat(
                      add(
                        parseFloat(taxReportSums.non_taxable_sales),
                        parseFloat(taxReportSums.taxable_sales)
                      )
                    ).toFixed(2)
                  }`
                }}</strong>
              </td>
              <td style="font-size: 14px!important;">
                <strong>{{
                  `$${parseFloat(taxReportSums.non_taxable_sales).toFixed(2)}`
                }}</strong>
              </td>
              <td style="font-size: 14px!important;">
                <strong>{{
                  `$${parseFloat(taxReportSums.taxable_sales).toFixed(2)}`
                }}</strong>
              </td>
              <td style="font-size: 14px!important;">
                <strong>{{
                  `$${parseFloat(taxReportSums.collected_tax).toFixed(2)}`
                }}</strong>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="getTaxReports()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import moment from "moment";
import { preciseAdd } from "@/common/preciseMath";
import {mapGetters} from "vuex"

export default {
  name: "SalesTaxReport",
  data: () => ({
    menu1: false,
    menu2: false,
    no_data: [null, "", undefined, "null"],
    headers: [
      { 
        text: "County", 
        value: "tax_rate", 
        sortable: false,
        align: "left", 
      },
      { 
        text: "Service Tax Rate", 
        value: "tax_rate", 
        sortable: false,
        align: "left", 
      },
      { 
        text: "Product Tax Rate", 
        value: "product_tax_rate", 
        sortable: false,
        align: "left", 
      },
      {
        text: "Gross Sales",
        value: "gross_sales",
        sortable: false,
        align: "left", 
      },
      {
        text: "Non-Taxable Sales",
        value: "non_taxable_sales",
        sortable: false,
        align: "left",
      },
      {
        text: "Taxable Sales",
        value: "taxable_sales",
        sortable: false,
        align: "left",
      },
      {
        text: "Collected Tax",
        value: "collected_tax",
        sortable: false,
        align: "left",
      }
    ],
    items: [],
    taxReportSums: null,
    fromDate: moment().subtract(1, "w").startOf("isoWeek").format("YYYY[-]MM[-]DD"),
    toDate: moment().subtract(1, "w").startOf("isoWeek").add(6, "d").format("YYYY[-]MM[-]DD"),
    loadedFromDate: null,
    loadedToDate: null,
    loading: false,
    taxReportsLoading: false,
    error_code: ""
  }),
  mounted() {
    this.initialize();
  },
  methods: {
    log(i) {
      console.log(i)
    },
    initialize() {
      this.loading = true
      this.getTaxReports()
        .then(values => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
    },
    getTaxReports() {
      this.taxReportsLoading = true;
      return new Promise((resolve, reject) => {
        let body = {
          organization_id: this.user.organization_id,
          from: this.fromDate,
          to: this.toDate
        };

        ApiService.get("/tax_report", body)
          .then(response => {
            let items = response.data.tax_report
            this.items = items.map(i => ({
              ...i, 
              gross_sales: parseFloat(this.add(parseFloat(i.non_taxable_sales), parseFloat(i.taxable_sales))).toFixed(2)
            }))
            this.taxReportSums = response.data.tax_report_sums
            this.loadedFromDate = body.from
            this.loadedToDate = body.to
            this.taxReportsLoading = false;
            resolve()
          })
          .catch(error => {
            this.taxReportsLoading = false;
            reject()
          });
      })
    },
    exportCSV() {
      let csvContent = "";
      let headers = [];
      let csvData = [];
      this.headers.forEach(i => {
        if (i.text != "Actions") {
          headers.push(i.text);
        }
      });
      headers.map(i => `"${i}"`);
      this.items.forEach(i => {
        let row = {
          name: !this.no_data.includes(i.name)
            ? `"${i.name}"`
            : `""`,
          tax_rate: !this.no_data.includes(i.tax_rate)
            ? `"${i.tax_rate}"`
            : `""`,
          product_tax_rate: !this.no_data.includes(i.product_tax_rate)
            ? `"${i.product_tax_rate}"`
            : `""`,
          gross_sales: !this.no_data.includes(i.gross_sales)
            ? `"${i.gross_sales}"`
            : `""`,
          non_taxable_sales: !this.no_data.includes(i.non_taxable_sales)
            ? `"${parseFloat(i.non_taxable_sales).toFixed(2)}"`
            : `""`,
          taxable_sales: !this.no_data.includes(i.taxable_sales)
            ? `"${parseFloat(i.taxable_sales).toFixed(2)}"`
            : `""`,
          collected_tax: !this.no_data.includes(i.collected_tax)
            ? `"${parseFloat(i.collected_tax).toFixed(2)}"`
            : `""`,
        };
        csvData.push(row);
      });

      if (
        !this.no_data.includes(this.taxReportSums) &&
        !this.no_data.includes(this.taxReportSums.taxable_sales) &&
        !this.no_data.includes(this.taxReportSums.non_taxable_sales) &&
        !this.no_data.includes(this.taxReportSums.collected_tax)
      ) {
        let totals = {
          name: `"Totals:"`,
          tax_rate: "",
          product_tax_rate: "",
          gross_sales: `"${parseFloat(this.add(parseFloat(this.taxReportSums.non_taxable_sales), parseFloat(this.taxReportSums.taxable_sales))).toFixed(2)}"`,
          non_taxable_sales: `"${parseFloat(this.taxReportSums.non_taxable_sales).toFixed(2)}"`,
          taxable_sales: `"${parseFloat(this.taxReportSums.taxable_sales).toFixed(2)}"`,
          collected_tax: `"${parseFloat(this.taxReportSums.collected_tax).toFixed(2)}"`,
        };
        csvData.push({new_line: `""`});
        csvData.push(totals);
      }

      csvContent += [
        headers.join(","),
        ...csvData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(data)
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        "Sales Tax Report " + this.titleDateFormat() + ".csv"
      );
      link.click();
    },
    titleDateFormat() {
      return `${this.loadedFromDate} - ${this.loadedToDate}`
    },
    add(a, b) {
      return preciseAdd(a, b)
    },
    totalSum(key) {
      let sum = 0.0;
      this.items.forEach(i => {
        let val = i[key];
        if (
          !this.no_data.includes(val) &&
          typeof parseFloat(val) === "number"
        ) {
          sum = this.add(parseFloat(sum), parseFloat(val));
        }
      });
      return sum;
    }
  },
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
<style>

.sales-tax-reports-wrap .header-search-single {
  padding-bottom: 20px;
}

td a {
  text-decoration: none;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}

.clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}

.sales-tax-reports-wrap .table-head-text {
  white-space: normal;
  text-align: left;
  min-width: 100px;
}

</style>
